module.exports = __webpack_public_path__ + "static/media/img1.5d5965cb.jpg";